import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'boolToWord' })
export class BoolToWordPipe implements PipeTransform {
  constructor() {}

  transform = (bool: string, language: string) => (bool ? 'Ja' : 'Nee');
}
